import React from "react";
function RightLeaf(props) {
    return (
      <svg
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="88.44 32.02 283.78 396.31"
        {...props}
      >
        <path
          d="M324.89 138.695l10.77 18.936c-20.528 47.666-46.449 88.542-73.753 122.998l-17.114-34.465 6.354 47.641C173.132 386.466 88.438 428.331 88.438 428.331c1.387-39.873 6.685-75.901 14.897-108.462l26.478-2.583-23.505-8.542c30.523-109.315 94.321-177.788 151.815-219.243l25.191 6.864-17.585-12.243c57.382-39.479 106.489-52.1 106.489-52.1-6.631 40.868-17.718 80.252-33.076 117.498l-14.252-10.825z"
          fill="#0D3727"
        />
        <path
          d="M363.683 40.044S153.831 236.434 93.339 419.257c0 0 47.919-145.189 270.344-379.213z"
          fill="#0D5137"
        />
        <path
          d="M298.929 111.132l-46.158-6.361 42.126 8.158 4.032-1.797zM263.217 153.283l-3.477 79.012-1.005-76.272 4.482-2.74zM232.839 188.078l-57.189 3.238 52.983.149 4.206-3.387zM185.457 252.485l-6.338 69.742 9.608-75.112-3.27 5.37zM152.036 297.374l-31.636 4.082 31.876-.882-.24-3.2zM131.906 339.815l.646 26.234-4.585-26.523 3.939.289z"
          fill="#0D5137"
        />
      </svg>
    );
  }

  export default RightLeaf;